import React from "react";
import { TouchableOpacity, View } from "react-native";
import { useTranslation } from "react-i18next";
import { SmallArrowDown, PathListContent, PathListContentProps, useThemedStyleFunction } from "@sodraberget/shared";
import { sideBarContentStyle } from "./side-bar-content.style";

type HierarchyPathProps = PathListContentProps & {
    __hierarchyLevel?: number;
    __parentPathId?: string;
    __childCount?: number;
    __expanded?: boolean;
    __onToggle?: () => void;
};

const PathListHierarchyContent = (props: HierarchyPathProps) => {
    const { __hierarchyLevel = 0, __childCount = 0, __expanded = true, __onToggle } = props;
    const style = useThemedStyleFunction(sideBarContentStyle);
    const [t] = useTranslation();

    return (
        <View style={__hierarchyLevel > 0 ? style.pathChildRow : undefined}>
            <PathListContent
                {...props}
                compact
                metadataPrefix={__hierarchyLevel > 0 ? t('compositeChildLabel') : undefined}
                metadataSuffix={__childCount > 0 ? t('compositeChildCount', { count: __childCount }) : undefined}
            />
            {__childCount > 0 && __onToggle && (
                <View style={style.pathCompositeFooter} pointerEvents="box-none">
                    <TouchableOpacity
                        style={style.pathExpandButton}
                        hitSlop={8}
                        accessibilityRole="button"
                        accessibilityLabel={t(__expanded ? 'collapseCompositeTrail' : 'expandCompositeTrail')}
                        accessibilityState={{ expanded: __expanded }}
                        onPress={(event) => {
                            event.stopPropagation();
                            __onToggle();
                        }}>
                        <SmallArrowDown style={__expanded
                            ? { ...style.pathExpandIcon, transform: [{ rotate: '180deg' }] }
                            : style.pathExpandIcon} />
                    </TouchableOpacity>
                </View>
            )}
        </View>
    );
};

export { HierarchyPathProps, PathListHierarchyContent };
